<span [class]="boxClass">
  @if (url && !failed) {
    <img class="h-full w-full object-cover" [src]="url" alt="" loading="lazy" (error)="failed = true" />
  } @else {
    <app-icon class="!h-[18px] !w-[18px] !text-[18px] !leading-none">inventory_2</app-icon>
  }
</span>
